'use client';
import { colors, font } from '@/theme/zeelool.theme';
import { FormControlLabel } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import { useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { AddressFormData } from '.';
import Checkbox from '../Form/Checkbox';
import Switch from '../Form/Switch';
import WapOnly from '../Responsive/WapOnly';
import WebOnly from '../Responsive/WebOnly';

const FormItemSetDefault = ({
  formData,
  isNeedPagePadding = true,
  variant = 'default',
}: {
  formData: UseFormReturn<AddressFormData>;
  isNeedPagePadding?: boolean;
  variant?: 'default' | 'paymentNewNoAddress';
}) => {
  const t = useTranslations('address');
  const [isChecked, setIsChecked] = useState(formData.getValues('default') === 1);
  const isPaymentNewNoAddress = variant === 'paymentNewNoAddress';
  const defaultAddressLabel = isPaymentNewNoAddress
    ? t('setAsDefaultShippingAddress')
    : t('setAsDefaultAddress');
  return (
    <>
      <WebOnly>
        <div
          className={`${isNeedPagePadding ? 'ml-16 ' : ''} ${isPaymentNewNoAddress ? 'pl-0 h-[20px]' : 'pl-8 h-[40px]'} flex items-center justify-between`}
        >
          <span
            className={
              isPaymentNewNoAddress ? 'text-[12px] leading-[14px]' : 'text-primary-black text-16'
            }
          >
            <FormControlLabel
              label={defaultAddressLabel}
              sx={{
                ...(isPaymentNewNoAddress
                  ? {
                      alignItems: 'center',
                      gap: '8px',
                      margin: 0,
                      '& .MuiButtonBase-root': {
                        padding: 0,
                        width: '18px',
                        height: '18px',
                      },
                      '& .MuiTypography-root': {
                        margin: 0,
                        color: colors.auxiliaryDarkGray,
                        fontFamily: font.br,
                        fontSize: '12px',
                        lineHeight: '14px',
                      },
                    }
                  : {
                      '& .PrivateSwitchBase-input': {
                        height: '24px',
                        width: '24px',
                      },
                      '& .MuiButtonBase-root': {
                        padding: '0',
                      },
                      '& .MuiTypography-root': {
                        fontFamily: font.br,
                        marginLeft: '6px',
                        color: colors.primaryBlack,
                      },
                    }),
              }}
              control={
                <Checkbox
                  checked={isChecked}
                  circle={isPaymentNewNoAddress}
                  fontSize={18}
                  inputProps={{ 'aria-label': 'controlled' }}
                  onChange={(event) => {
                    if (event.target.checked) {
                      formData.setValue('default', 1);
                      setIsChecked(true);
                    } else {
                      formData.setValue('default', 2);
                      setIsChecked(false);
                    }
                  }}
                  sx={{
                    padding: 0,
                  }}
                />
              }
            />
          </span>
        </div>
      </WebOnly>
      <WapOnly>
        {isPaymentNewNoAddress ? (
          <div className="flex min-h-[20px] items-center">
            <FormControlLabel
              label={defaultAddressLabel}
              sx={{
                alignItems: 'center',
                gap: '8px',
                margin: 0,
                '& .MuiButtonBase-root': {
                  padding: 0,
                  width: '18px',
                  height: '18px',
                },
                '& .MuiTypography-root': {
                  margin: 0,
                  color: colors.auxiliaryDarkGray,
                  fontFamily: font.br,
                  fontSize: '12px',
                  lineHeight: '14px',
                },
              }}
              control={
                <Checkbox
                  checked={isChecked}
                  circle
                  fontSize={18}
                  inputProps={{ 'aria-label': 'controlled' }}
                  onChange={(event) => {
                    if (event.target.checked) {
                      formData.setValue('default', 1);
                      setIsChecked(true);
                    } else {
                      formData.setValue('default', 2);
                      setIsChecked(false);
                    }
                  }}
                  sx={{
                    padding: 0,
                  }}
                />
              }
            />
          </div>
        ) : (
          <div className="mx-16 flex items-center justify-between pb-64">
            <span className="text-primary-black text-14">{defaultAddressLabel}</span>
            <Switch
              checked={isChecked}
              inputProps={{ 'aria-label': 'controlled' }}
              onChange={(event) => {
                if (event.target.checked) {
                  formData.setValue('default', 1);
                  setIsChecked(true);
                } else {
                  formData.setValue('default', 2);
                  setIsChecked(false);
                }
              }}
              width={42}
              height={22}
            />
          </div>
        )}
      </WapOnly>
    </>
  );
};

export default FormItemSetDefault;
